module.exports = __webpack_public_path__ + "static/media/wp_1.b1dc1528.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_1.png
// module id = 30
// module chunks = 0